// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import router from "./router";
import ElementUi from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "@/assets/style/normalize.css"
// icon css
import "@/assets/icon/common/icon.css"
// icon svg
require ("@/assets/icon/control/icon.js")
require ("@/assets/icon/control/batch/icon.js")
require ("@/assets/icon/billboard/icon.js")
require ("@/assets/icon/data/icon.js")

//引入iconfonts.css
import "@/styles/index.css"; // global css

import App from "./App";

// 兼容性处理
import promise from "es6-promise";
// import echarts from 'echarts';
import msg from "./utils/msg";
import axios from "@/utils/axios";
import validate from "@/utils/validate";
import longvalidate from "@/utils/longvalidate";
import toExcel from "@/utils/excel/json2excel";
/*video*/
import VideoPlayer from 'vue-video-player';
import 'video.js/dist/video-js.css';
import 'videojs-flash';
// time-ago组件
import VueTimeago from "vue-timeago";

promise.polyfill();
require("promise.prototype.finally").shim();

Vue.use(ElementUi, {
  size: "medium"
});

Vue.config.productionTip = false;
Vue.prototype.validate = validate;
Vue.prototype.longvalidate = longvalidate;
Vue.prototype.msg = msg;
Vue.prototype.$http = axios;
Vue.prototype.$toExcel = toExcel;

Vue.use(VideoPlayer)

// 全局变量api
global.api = require("./api.js");
global.preImgUrl = process.env.BASE_API;
// 全局常量
global.constant = require("./utils/constant.js");
// 全局函数
global.funcset = require("./utils/funcset");

Vue.use(VueTimeago, {
  name: "Timeago", // Component name, `Timeago` by default
  locale: "zh-CN", // Default locale
  locales: {
    "zh-CN": require("date-fns/locale/zh_cn")
  }
});

/* eslint-disable no-new */
new Vue({
    el: "#app",
    router,
    template: "<App/>",
    components: {App},
    data: {
      // 默认使用之前的
      company_chinese_simple_name: localStorage.setItem("company_chinese_simple_name", ""),
      company_chinese_name: localStorage.setItem("company_chinese_name", ""),
      company_english_name: localStorage.setItem("company_english_name", ""),
      company_english_simple_name: localStorage.setItem("company_english_simple_name", ""),
      base64_logo: localStorage.setItem("base64_logo", ""),
      is_show_record: localStorage.setItem("is_show_record", ""),
      logo_height: localStorage.setItem("logo_height", ""),
      logo_width: localStorage.setItem("logo_width", ""),
      title: localStorage.setItem("company_chinese_simple_name", "") + "校园物联网管理平台",

      // 单点登录用户数据验证获取完成标志
      sso_user_ready_flag: false,
    },
    methods: {
      // 限时提醒
      deadline_info () {
        this.$http.get (api.deadline_info_url).then((resp) => {
          if (resp.data.success) {
            let data = resp.data.data
            if (data.is_notify) {
              this.msg.notify(
                data.notify_msg,
                '续费提醒',
                "warning",
                5000
              )
            }
          }
        })
      },
      set_company_info() {
        this.$http.get(api.company_info_url).then((resp => {
          if (resp.data.success) {
            this.company_chinese_simple_name = !resp.data.data.company_chinese_simple_name || resp.data.data.company_chinese_simple_name == "null" ? "" : resp.data.data.company_chinese_simple_name;
            this.company_chinese_name = !resp.data.data.company_chinese_name || resp.data.data.company_chinese_name == "null" ? "" : resp.data.data.company_chinese_name;
            this.company_english_name = !resp.data.data.company_english_name || resp.data.data.company_english_name == "null" ? "" : resp.data.data.company_english_name;
            this.company_english_simple_name = !resp.data.data.company_english_simple_name || resp.data.data.company_english_simple_name == "null" ? "" : resp.data.data.company_english_simple_name;
            this.base64_logo = !resp.data.data.base64_logo || resp.data.data.base64_logo == "null" ? "" : 'data: image / jpeg;Base64, ' + resp.data.data.base64_logo;
            this.is_show_record = !resp.data.data.is_show_record || resp.data.data.is_show_record == "null" ? "" : resp.data.data.is_show_record;
            this.logo_height = !resp.data.data.logo_height || resp.data.data.logo_height == "null" ? "" : resp.data.data.logo_height + 'px';
            this.logo_width = !resp.data.data.logo_width || resp.data.data.logo_width == "null" ? "" : resp.data.data.logo_width + 'px';

            localStorage.setItem("company_chinese_simple_name", this.company_chinese_simple_name);
            localStorage.setItem("company_chinese_name", this.company_chinese_name);
            localStorage.setItem("company_english_name", this.company_english_name);
            localStorage.setItem("company_english_simple_name", this.company_english_simple_name);
            localStorage.setItem("base64_logo", this.base64_logo);
            localStorage.setItem("is_show_record", this.is_show_record);
            localStorage.setItem("logo_height", this.logo_height);
            localStorage.setItem("logo_width", this.logo_width);
            document.title = this.company_chinese_simple_name + "校园物联网管理平台"

          }

        }))

      },
      // 获取url参数: 用于单点登录
      get_arg(name) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
        var r = window.location.search.substr(1).match(reg);
        if (r != null) return unescape(r[2]);
        return null;
      },
      // 检测ticket是否过期
      ticket_login() {
        let ticket = this.get_arg('ticket');
        // 没有ticket表示不需要进行单点登录
        if (!ticket) {
          return
        }
        // 刷新行为，表示为原来的ticket，则不需要重新验证身份登录
        if (localStorage.ticket === ticket) {
          return
        }
        localStorage.clear();
        // 后台身份验证
        const loading = this.$loading({
          lock: true,
          text: '验证身份信息..',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.8)'
        });
        this.$http.post(api.loginsso_url, {ticket: ticket}).then((resp) => {
          if (resp.data.success) {
            let token = resp.data.data
            let username = resp.data.username
            let can_all = resp.data.can_all
            let module_permissions = resp.data.module_permissions
            let version = resp.data.version
            let max_node_num = resp.data.max_node_num
            let softname = resp.data.softname
            localStorage.setItem('token', token)
            localStorage.setItem('username', username)
            localStorage.setItem('can_all', can_all)
            localStorage.setItem(
              'module_permissions',
              JSON.stringify(module_permissions)
            )
            // 当权限数据获取完成后，设置单点登录用户数据就绪标志
            this.sso_user_ready_flag = !this.sso_user_ready_flag;

            let can_control = false
            if (can_all) {
              can_control = true
            } else {
              if (module_permissions) {
                can_control = module_permissions.control.control_main.manage
              }
            }
            localStorage.setItem('can_control', can_control)
            localStorage.setItem('version', version)
            localStorage.setItem('max_node_num', max_node_num)
            localStorage.setItem('softname', softname)
            localStorage.setItem('ticket', ticket)

            //设置请求头
            this.$http.defaults.headers.common[
              'Authorization'
              ] = localStorage.getItem('token')
            let redirect = decodeURIComponent(
              this.$route.query.redirect || '/'
            )
            this.$router.push(redirect)
          } else {
            this.$router.push('/login');
            this.msg.msg(resp.data.data, 'e')
          }
        }).finally(() => {
          loading.close()
        })
      }
    },

    created() {
        this.deadline_info()
        this.set_company_info();
        this.ticket_login();

        // 设备控制场景执行
        // 不为null时标识有延时保护场景正在执行
        // 初始化
        localStorage.setItem("doing_scene", "null")
    },
})
;



// WEBPACK FOOTER //
// ./src/main.js